import { factorySetStateAction } from '../factory'
// Defined Device Constants to bind SAGA functions with Redux Dispatcher
const actions = {
  SET_STATE: 'clinic/SET_STATE',
  GET_CLINICID: 'clinic/GET_CLINICID',
  GET_CLINICS: 'clinic/GET_CLINICS',
  ADD_CLINIC: 'clinic/ADD_CLINIC',
  UPDATE_CLINIC: 'clinic/UPDATE_CLINIC',
  UPDATE_SETTINGS: 'clinic/UPDATE_SETTINGS',
  GET_CLINIC_DETAIL: 'clinic/GET_CLINIC_DETAIL',
  GET_CLINIC_COMPLETE_PROFILE: 'clinic/GET_CLINIC_COMPLETE_PROFILE',
  GET_CLINIC_USERS: 'clinic/GET_CLINIC_USERS',
  SEND_DOWNLOAD_REPORT: 'clinic/SEND_DOWNLOAD_REPORT',
  EMAIL_REPORT_LINK: 'clinic/EMAIL_REPORT_LINK',
  SEND_EMAIL_REPORT: 'clinic/SEND_EMAIL_REPORT',
  CHANGE_SELECTED_CLINIC: 'clinic/CHANGE_SELECTED_CLINIC',
  GET_CLINIC_FLOOR: 'clinic/GET_CLINIC_FLOOR',
  SEND_EMAIL_BILLING_REPORT: 'clinic/SEND_EMAIL_BILLING_REPORT',
  IMPORT_PCC_RESIDENTS: 'clinic/IMPORT_PCC_RESIDENTS',
  IMPORT_NOTES: 'clinic/IMPORT_NOTES',
  GET_CIP_CREDENTIALS: 'clinic/GET_CIP_CREDENTIALS',
  SET_CIP_CREDENTIALS: 'clinic/SET_CIP_CREDENTIALS',
}

export const clinicSetState = factorySetStateAction(actions.SET_STATE)
export const changeSelectedClinic = (payload) => ({
  type: actions.CHANGE_SELECTED_CLINIC,
  payload,
})

export const getClinicDetail = (payload) => ({
  type: actions.GET_CLINIC_DETAIL,
  payload,
})

export const getClinicFloors = (payload) => ({
  type: actions.GET_CLINIC_FLOOR,
  payload,
})

export const importpccresidents = (payload) => ({
  type: actions.IMPORT_PCC_RESIDENTS,
  payload,
})

export const importNotes = (payload) => ({
  type: actions.IMPORT_NOTES,
  payload,
})

export const getCipCredentials = (payload) => ({
  type: actions.GET_CIP_CREDENTIALS,
  payload,
})

export const setCipCredentials = (payload) => ({
  type: actions.SET_CIP_CREDENTIALS,
  payload,
})

export default actions
